import * as React from 'react';

export interface IABCallButtonProps {
  isFromBuilder: boolean;
  isCallButtonExperimentActive?: boolean;
}

export const ABCallButtonComponent = (props: IABCallButtonProps) => {
  const { isFromBuilder, isCallButtonExperimentActive } = props;
  let text;

  if (isFromBuilder) {
    text = isCallButtonExperimentActive ? 'Хочу проконсультироваться' : 'Контакты застройщика';
  } else {
    text = 'Показать телефон';
  }

  return <>{text}</>;
};
